import type { MPLOffer, MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import type { sendEventOnShowOfferOnMplCreditSelectionScreen } from 'shared/lib/sendGAEvents';
import type { TOffer } from 'shared/types/TRankingService';

import { getAnalyticsBadgesParam } from './getAnalyticsBadgesParam';
import { getAnalyticsProductParams } from './getAnalyticsProductParams';
import { getAnalyticsSummariesParams } from './getAnalyticsSummariesParams';
import type { TCommonMplAnalyticsParams } from './getCommonMplAnalyticsParams';

export const getAnalyticsOnShowOfferData = (
  commonMplAnalyticsParams: TCommonMplAnalyticsParams,
  offer: TOffer | MPLOffer | MPLPreApprovalOffer,
): Parameters<typeof sendEventOnShowOfferOnMplCreditSelectionScreen>[0] => ({
  ...commonMplAnalyticsParams,
  ...getAnalyticsProductParams(offer),
  ...getAnalyticsSummariesParams(offer),
  badges: getAnalyticsBadgesParam(offer),
  status: offer.status,
});
